(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** @type {IntersectionObserver | null} */
  let observer = null;
  /** @type {Set<Element>} */
  const active = new Set();
  let rafId = 0;
  let started = false;
  let lenisHooked = false;

  function parseRangePx(el) {
    const attr = el.getAttribute('data-xo-parallax-range');
    if (attr != null && attr !== '') {
      const n = parseFloat(attr);
      if (!Number.isNaN(n)) return Math.max(0, n);
    }
    return 24;
  }

  /**
   * @param {Element} el
   */
  function updateOne(el) {
    if (!(el instanceof HTMLElement)) return;
    const range = parseRangePx(el);
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    const center = rect.top + rect.height / 2;
    const viewportMid = vh / 2;
    const denom = vh * 0.42 + Math.max(rect.height * 0.28, 1);
    let t = (center - viewportMid) / denom;
    t *= 1.18;
    if (t < -1) t = -1;
    if (t > 1) t = 1;
    const shiftPx = t * range * -1;
    el.style.setProperty('--xo-parallax-shift', `${shiftPx.toFixed(2)}px`);
  }

  function flush() {
    rafId = 0;
    active.forEach((el) => {
      if (el.isConnected) updateOne(el);
    });
  }

  function schedule() {
    if (rafId) return;
    rafId = requestAnimationFrame(flush);
  }

  function tryLenisHook() {
    if (lenisHooked) return;
    const lenis = window.__xoLenis;
    if (lenis && typeof lenis.on === 'function') {
      lenis.on('scroll', schedule);
      lenisHooked = true;
    }
  }

  function observeNew(root) {
    if (reducedMotion || !observer) return;
    root.querySelectorAll('[data-xo-parallax]:not([data-xo-parallax-bound])').forEach((el) => {
      el.setAttribute('data-xo-parallax-bound', 'true');
      observer.observe(el);
    });
  }

  function start() {
    if (reducedMotion || started) return;
    started = true;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) active.add(entry.target);
          else active.delete(entry.target);
        });
        schedule();
      },
      { rootMargin: '120px 0px', threshold: 0 }
    );

    observeNew(document);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    tryLenisHook();
    requestAnimationFrame(tryLenisHook);
    setTimeout(tryLenisHook, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) observeNew(event.target);
  });

  window.addEventListener('pagereveal', () => {
    observeNew(document);
    tryLenisHook();
    schedule();
  });
})();
